export default __webpack_public_path__ + "5efec35742050a8f764fd7cdecc38f9e.png";